// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-search-search__errorMessage {\n  color: red;\n  font-size: 12px;\n  letter-spacing: 0.05rem;\n  padding-left: 0.25rem;\n}\n", "",{"version":3,"sources":["webpack://./src/components/search/search.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;AACF","sourcesContent":[".errorMessage {\n  color: red;\n  font-size: 12px;\n  letter-spacing: 0.05rem;\n  padding-left: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "src-components-search-search__errorMessage"
};
export default ___CSS_LOADER_EXPORT___;
